import { render, staticRenderFns } from "./FeedBackModal.vue?vue&type=template&id=253255a0&scoped=true"
import script from "./FeedBackModal.vue?vue&type=script&lang=js"
export * from "./FeedBackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253255a0",
  null
  
)

export default component.exports